import { coerceLabel } from '@/_shared/lib/coerce-label';

type Row = Record<string, string>;

function coerceRow(row: Record<string, unknown>): Row {
  const coerced: Row = {};
  for (const [k, v] of Object.entries(row)) {
    coerced[k] = coerceLabel(v);
  }
  return coerced;
}

function parseColumnar(obj: Record<string, unknown>): Row[] {
  const columns = obj['columns'];
  const rows = obj['rows'];
  if (!Array.isArray(columns) || !Array.isArray(rows)) return [];
  const colNames = columns as string[];
  return (rows as unknown[][]).map((row) => {
    const out: Row = {};
    for (let i = 0; i < colNames.length; i++) {
      out[colNames[i]!] = coerceLabel(row[i]);
    }
    return out;
  });
}

export function parseRows(content: string): Row[] {
  try {
    const parsed: unknown = JSON.parse(content);
    if (Array.isArray(parsed)) {
      return (parsed as Record<string, unknown>[]).map(coerceRow);
    }
    // Columnar format: {columns: string[], rows: unknown[][]}
    if (typeof parsed === 'object' && parsed !== null) {
      return parseColumnar(parsed as Record<string, unknown>);
    }
  } catch {
    // not valid JSON
  }
  return [];
}

interface TableMeta {
  title?: string;
  totalRows: number | null;
}

/** Extract optional `title` and `totalRows` hints from an assistant table payload's metadata. */
export function parseTableMeta(metadata: unknown): TableMeta {
  const meta: TableMeta = { totalRows: null };
  if (metadata && typeof metadata === 'object') {
    if ('title' in metadata && typeof metadata.title === 'string') meta.title = metadata.title;
    if ('totalRows' in metadata && typeof metadata.totalRows === 'number') meta.totalRows = metadata.totalRows;
  }
  return meta;
}
